import React from 'react';
import {
    ListOutlined,
    EventOutlined,
    RefreshOutlined,
    CheckCircleOutlined,
    EmojiPeopleOutlined,
    LocalOfferOutlined,
    DescriptionOutlined,
    HomeOutlined,
    LocationOnOutlined,
    ThumbUpOutlined,
    BusinessCenterOutlined,
    PowerOutlined,
    UndoOutlined,
} from '@material-ui/icons';
import {
    TEMPLATE_CATEGORY_ALL,
    TEMPLATE_CATEGORY_GREETING,
    TEMPLATE_CATEGORY_WELCOME,
    TEMPLATE_CATEGORY_APPOINTMENT,
    TEMPLATE_CATEGORY_FOLLOW_UP,
    TEMPLATE_CATEGORY_GRATITUDE,
    TEMPLATE_CATEGORY_PROMOTION,
    TEMPLATE_CATEGORY_DOCUMENTATION,
    TEMPLATE_CATEGORY_LOCATION,
    TEMPLATE_CATEGORY_CLOSING,
    TEMPLATE_CATEGORY_BDC,
    TEMPLATE_CATEGORIES_WITH_ICONS,
    ITemplateCategory,
} from '../constants/templates';

type TObtainTemplateCategoriesHelper = {
    translation: (key: string) => string;
    iconsShow: boolean;
};

export const obtainTemplateCategoriesHelper = ({
    translation,
    iconsShow,
}: TObtainTemplateCategoriesHelper): ITemplateCategory[] => {
    const styles = { fontSize: 16 };
    return TEMPLATE_CATEGORIES_WITH_ICONS.map((category) => {
        const getIcon = () => {
            if (!iconsShow) return null;
            switch (category.id) {
                case TEMPLATE_CATEGORY_ALL:
                    return <ListOutlined style={styles} />;
                case TEMPLATE_CATEGORY_GREETING:
                    return <EmojiPeopleOutlined style={styles} />;
                case TEMPLATE_CATEGORY_WELCOME:
                    return <HomeOutlined style={styles} />;
                case TEMPLATE_CATEGORY_APPOINTMENT:
                    return <EventOutlined style={styles} />;
                case TEMPLATE_CATEGORY_FOLLOW_UP:
                    return <RefreshOutlined style={styles} />;
                case TEMPLATE_CATEGORY_GRATITUDE:
                    return <ThumbUpOutlined style={styles} />;
                case TEMPLATE_CATEGORY_PROMOTION:
                    return <LocalOfferOutlined style={styles} />;
                case TEMPLATE_CATEGORY_DOCUMENTATION:
                    return <DescriptionOutlined style={styles} />;
                case TEMPLATE_CATEGORY_LOCATION:
                    return <LocationOnOutlined style={styles} />;
                case TEMPLATE_CATEGORY_CLOSING:
                    return <CheckCircleOutlined style={styles} />;
                case TEMPLATE_CATEGORY_BDC:
                    return <BusinessCenterOutlined style={styles} />;
                default:
                    return <ListOutlined style={styles} />;
            }
        };

        return {
            ...category,
            label: translation(`TemplatesTwilio.${category.label}`),
            icon: getIcon(),
            subcategories: category.subcategories?.map((subcategory) => ({
                ...subcategory,
                label: translation(`TemplatesTwilio.${subcategory.label}`),
            })),
        };
    });
};
